import React, { useContext, useState, useEffect } from 'react';
// import { useSelector, useDispatch } from 'react-redux';
import {
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  Checkbox,
  Divider,
  FormControlLabel,
  Grid,
  Typography
} from '@mui/material';
// import { CircularProgress } from '@mui/material';
import { useLazyQuery, } from '@apollo/client';
import { USER_QUERY } from '../../../../graph/UserGraph';
import PageLoadingSkeleton from '../../../skeletons/PageLoadingSkeleton';
import { JSONToTable } from '../../../table/JSONToTable';

const ProfileSettings = (props) => {

  const [userData, setUserData] = useState(null)

  const [getLazyUser, lazyUser] = useLazyQuery(USER_QUERY);


  useEffect(() => {
    getLazyUser({
      onCompleted: ((data) => {
        setUserData(data.me)
      })
    })
  }, [])

  // let userData = useSelector(state => state.user?.user_details)
  // let orgDetailsData = useSelector(state => state.user?.org_details)

  if (userData === null) return <PageLoadingSkeleton variant={"rectangular"} marginx={0} marginy={0} count={1} height={500} />

  return (
    <form {...props}>
      <Card>
        <CardHeader
          subheader="Manage your profile"
          title="Profile"
        />
        <Divider />
        <CardContent>

          <JSONToTable data={userData} keysToExclude={["id", "__typename"]} />

        </CardContent>
        <Divider />
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'flex-end',
            p: 2
          }}
        >
          <Button
            color="primary"
            variant="contained"
          >
            Save
          </Button>
        </Box>
      </Card>
    </form>
  )
  // } else {
  //   return <CircularProgress />
  // }
};

export default ProfileSettings;
